import { render, staticRenderFns } from "./pos-transaction.vue?vue&type=template&id=6449672d&"
import script from "./pos-transaction.vue?vue&type=script&lang=js&"
export * from "./pos-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6449672d')) {
      api.createRecord('6449672d', component.options)
    } else {
      api.reload('6449672d', component.options)
    }
    module.hot.accept("./pos-transaction.vue?vue&type=template&id=6449672d&", function () {
      api.rerender('6449672d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/payment/pos-transaction.vue"
export default component.exports